export * from "./controller";
export const HtmlTemplate: string =
  require("!html-loader!./index.html").default;
